<template>
  <v-footer id="footer" class="footer py-7 px-md-10" color="#25233F" dark>
    <div v-if="$vuetify.breakpoint.smAndUp" class="footer__wrapper ">
      <v-row class="mb-3">
        <v-col cols="3">
          <h4 class="mb-2">{{ footerData.agreementTitle }}</h4>
          <p
            v-for="item in footerData.agreementItems"
            :key="item"
            class="footerText"
          >
            {{ item }}
          </p>
          <p class="footerText mt-2">
            {{ footerData.agreementText }}
          </p>
          <h4 class="mb-2">{{ footerData.foundationGoal.title }}</h4>
          <p
            v-for="item in footerData.foundationGoal.items"
            :key="item"
            class="footerText"
          >
            {{ item }}
          </p>
          <h4 class="mb-2">{{ footerData.foundationBeneficiaries.title }}</h4>
          <p
            v-for="item in footerData.foundationBeneficiaries.items"
            :key="item"
            class="footerText"
          >
            {{ item }}
          </p>
          <h4 class="footerText mb-2">{{ footerData.requisites.title }}:</h4>
          <p
            v-for="item in footerData.requisites.items"
            :key="item"
            class="footerText"
          >
            {{ item }}
          </p>
          <h4 class="mt-2">{{ footerData.paymentsSecurity.title }}:</h4>
          <p class="footerText mt-2">
            {{ footerData.paymentsSecurity.text }}
            <button @click="onSecurityDetailsClick" class="detailsButton">
              {{
                `${
                  isSecurityDescriptionVisible
                    ? footerData.paymentsSecurity.hideTitle
                    : footerData.paymentsSecurity.moreTitle
                }`
              }}
            </button>
          </p>
          <div class="d-flex align-center">
            <img
              class="paymentImg"
              :src="require('../assets/img/visa.png')"
              alt="Visa"
            />
            <img
              class="paymentImg"
              :src="require('../assets/img/mastercard.png')"
              alt="MasterCard"
            />
            <img
              class="paymentImg"
              :src="require('../assets/img/arca.jpeg')"
              alt="ArCa"
            />
          </div>
          <p v-if="isSecurityDescriptionVisible" class="footerText mt-2">
            {{ footerData.paymentsSecurity.description }}
          </p>
        </v-col>
        <v-col cols="3">
          <h4>{{ footerData.organiserTitle }}</h4>
          <p class="footerText mt-4">
            {{ footerData.organiserName }}
            <RouterLink class="teamLink" to="/team">{{
              footerData.teamLink
            }}</RouterLink>
          </p>
        </v-col>
        <v-col cols="3">
          <h4>{{ footerData.contactsLabel }}</h4>
          <p class="footerText mt-4">
            {{ footerData.contactsPhoneLabel }}:
            <a class="contactLink" href="tel:+37495576378">+374 95 576378</a>
          </p>
          <p class="footerText mt-4">
            Email:
            <a class="contactLink" href="mailto:lsaran.armenia@gmail.com"
              >lsaran.armenia@gmail.com</a
            >
          </p>
        </v-col>
        <v-col cols="3">
          <h4>{{ footerData.socialLinksLabel }}</h4>
          <nav class="socialWrapper">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://t.me/lsaranconference"
            >
              <TelegramIcon class="socialIcon" />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.instagram.com/lsaran_international?igsh=MTAxcjVjNXpucXliNA=="
            >
              <InstagramIcon class="socialIcon" />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.facebook.com/share/15YxMqKZMz/?mibextid=wwXIfr"
            >
              <FacebookIcon class="socialIcon" />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.linkedin.com/company/lsaran/posts/?feedView=all"
            >
              <LinkedIn class="socialIcon" />
            </a>
          </nav>
        </v-col>
      </v-row>
      <div class="d-flex align-center justify-end">
        <!--        <div class="footer__wrapper-links">-->
        <!--          <a href="#">Пользовательское соглашение</a>-->
        <!--        </div>-->
        <p class="footer__wrapper-rights">© Lsaran {{ currentYear }}</p>
      </div>
    </div>
    <div v-else class="footer__wrapper-mb">
      <div class="footer__wrapper-mb-organizer">
        <h3 class="my-10">{{ footerData.organiserTitle }}</h3>
        <p class="footerText mt-4">
          {{ footerData.organiserName }}
          <RouterLink class="teamLink" to="/team">{{
            footerData.teamLink
          }}</RouterLink>
        </p>
      </div>
      <div class="footer__wrapper-mb-terms">
        <h3 class="mt-10 mb-2">{{ footerData.agreementTitle }}</h3>
        <p
          v-for="item in footerData.agreementItems"
          :key="item"
          class="footerText"
        >
          {{ item }}
        </p>
        <h4 class="mb-2">{{ footerData.foundationGoal.title }}</h4>
        <p
          v-for="item in footerData.foundationGoal.items"
          :key="item"
          class="footerText"
        >
          {{ item }}
        </p>
        <h4 class="mb-2">{{ footerData.foundationBeneficiaries.title }}</h4>
        <p
          v-for="item in footerData.foundationBeneficiaries.items"
          :key="item"
          class="footerText"
        >
          {{ item }}
        </p>
        <p class="my-8">{{ footerData.requisites.title }}:</p>
        <p v-for="item in footerData.requisites.items" :key="item">
          {{ item }}
        </p>
        <h4 class="mt-2">{{ footerData.paymentsSecurity.title }}:</h4>
        <p class="footerText mt-2">
          {{ footerData.paymentsSecurity.text }}
          <button @click="onSecurityDetailsClick" class="detailsButton">
            {{
              `${
                isSecurityDescriptionVisible
                  ? footerData.paymentsSecurity.hideTitle
                  : footerData.paymentsSecurity.moreTitle
              }`
            }}
          </button>
        </p>
        <div class="d-flex align-center">
          <img
            class="paymentImg"
            :src="require('../assets/img/visa.png')"
            alt="Visa"
          />
          <img
            class="paymentImg"
            :src="require('../assets/img/mastercard.png')"
            alt="MasterCard"
          />
          <img
            class="paymentImg"
            :src="require('../assets/img/arca.jpeg')"
            alt="ArCa"
          />
        </div>
        <p v-if="isSecurityDescriptionVisible" class="footerText mt-2">
          {{ footerData.paymentsSecurity.description }}
        </p>
      </div>
      <div class="footer__wrapper-mb-terms">
        <h4>{{ footerData.contactsLabel }}</h4>
        <p class="footerText mt-4">
          {{ footerData.contactsPhoneLabel }}:
          <a class="contactLink" href="tel:+37495576378">+374 95 576378</a>
        </p>
        <p class="footerText mt-4">
          Email:
          <a class="contactLink" href="mailto:lsaran.armenia@gmail.com"
            >lsaran.armenia@gmail.com</a
          >
        </p>
      </div>
      <div class="footer__wrapper-mb-terms">
        <h4>{{ footerData.socialLinksLabel }}</h4>
        <nav class="socialWrapper">
          <a
            rel="noreferrer"
            target="_blank"
            href="https://t.me/lsaranconference"
          >
            <TelegramIcon class="socialIcon" />
          </a>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.instagram.com/lsaran_international?igsh=MTAxcjVjNXpucXliNA=="
          >
            <InstagramIcon class="socialIcon" />
          </a>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.facebook.com/share/15YxMqKZMz/?mibextid=wwXIfr"
          >
            <FacebookIcon class="socialIcon" />
          </a>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.linkedin.com/company/lsaran/posts/?feedView=all"
          >
            <LinkedIn class="socialIcon" />
          </a>
        </nav>
      </div>
    </div>
  </v-footer>
</template>

<script>
import TelegramIcon from "@/components/icons/TelegramIcon.vue";
import InstagramIcon from "@/components/icons/InstagramIcon.vue";
import FacebookIcon from "@/components/icons/FacebookIcon.vue";
import LinkedIn from "@/components/icons/LinkedInIcon.vue";

export default {
  name: "Footer",
  components: { LinkedIn, FacebookIcon, InstagramIcon, TelegramIcon },
  computed: {
    footerData() {
      return this.$t("footer");
    }
  },
  data() {
    return {
      isSecurityDescriptionVisible: false,
      currentYear: new Date().getFullYear()
    };
  },
  methods: {
    onSecurityDetailsClick() {
      this.isSecurityDescriptionVisible = !this.isSecurityDescriptionVisible;
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../assets/style/vars"
@import "../assets/style/media"

.footer
  &__wrapper
    width: 100%
    font-size: .8rem
    line-height: .9rem
    letter-spacing: 0.02em
    &-mb
      padding-bottom: 100px
      &-terms
        margin-top: 80px
        a
          color: #FFA903
          font-family: Roboto, sans-serif
          font-style: normal
          font-weight: normal
          font-size: 16px
          line-height: 24px
    &-links
      a
        color: #FFA903

.teamLink
  color: #FFA903

.footerText
  font-size: 12px
  line-height: 16px

.contactLink
  color: inherit

.paymentImg
  width: 64px
  object-fit: contain
  margin-right: 16px


.detailsButton
  color: $activeColor

.socialWrapper
  display: flex
  align-items: center
  grid-gap: 8px
  margin-top: 8px

.socialIcon
  width: 28px
  height: 28px
  color: $white
  transition: color .2s

  &:hover
    color: $activeColor

  @include mobileMedia
    width: 36px
    height: 36px
</style>
